/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Pit1_TInputs */

const en_to_yaml_pit1_t = /** @type {(inputs: To_Yaml_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not strip the quotes the converter added`)
};

const ko_to_yaml_pit1_t = /** @type {(inputs: To_Yaml_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변환기가 넣은 인용부호를 지우지 마세요`)
};

const ja_to_yaml_pit1_t = /** @type {(inputs: To_Yaml_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換器が付けた引用符を外さないでください`)
};

/**
* | output |
* | --- |
* | "Do not strip the quotes the converter added" |
*
* @param {To_Yaml_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_pit1_t = /** @type {((inputs?: To_Yaml_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_pit1_t(inputs)
	if (locale === "ko") return ko_to_yaml_pit1_t(inputs)
	return ja_to_yaml_pit1_t(inputs)
});